import type { TableColumn } from '@library/types/utils';
import type { UnsettlementsColumns } from '@library/types/unsettlements';

export const UNSETTLEMENTS_TABLE_HEADER: Array<
  TableColumn<UnsettlementsColumns>
> = [
  {
    column: 'actionId',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'projectionId',
    essential: true,
    label: 'Projection',
    sortEnabled: false,
    width: 'w-[10%]'
  },
  {
    column: 'adminName',
    essential: true,
    label: 'Admin',
    sortEnabled: false,
    width: 'w-[20%]'
  },
  {
    column: 'createdAt',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-[15%]'
  },
  {
    column: 'updatedAt',
    essential: true,
    label: 'Updated At',
    sortEnabled: false,
    width: 'w-[15%]'
  },
  {
    column: 'reason',
    essential: true,
    label: 'Reason',
    sortEnabled: false,
    width: 'w-[20%]'
  },
  {
    column: 'completedOn',
    essential: true,
    label: 'Completed On',
    sortEnabled: false,
    width: 'w-[10%]'
  }
];

export const UNSETTLEMENTS_TABLE_ORDERED_COLUMNS: Array<UnsettlementsColumns> =
  [
    // intentionally not alphabetical - the order of the columns is important
    'actionId',
    'projectionId',
    'adminName',
    'createdAt',
    'updatedAt',
    'reason',
    'completedOn'
  ];

export const FETCH_UNSETTLEMENTS_PER_PAGE_COUNT = 50;
